define [], () ->
  name: 'payment', url: '^/payment/{application_id}/{shareToken}/', public: true
  template: require("./payment.jade")
  controller: require("./payment.coffee")
  children: [
    name: 'verify', url: 'verify/'
    template: require('./verify/verify.jade')
    params:
      application: null
      context: 'applicant-payment'
    children: [
      name: 'start',
      controller: require("./start/start.coffee")
      template: require("./start/start.jade")
    ,
      name: 'disclaimer', url: 'disclaimer/'
      controller: require("./../verifications/disclaimer/disclaimer.coffee")
      template: require("./../verifications/disclaimer/disclaimer.jade")
    ,
      name: 'personal_info', url: 'personal_info/'
      controller: require("./../verifications/personal_info/personal_info.coffee")
      template: require("./../verifications/personal_info/personal_info.jade")
    ,
      name: 'questions', url: 'questions/'
      controller: require("./../verifications/questions/questions.coffee")
      template: require("./../verifications/questions/questions.jade")
      params:
        questions: []
    ,
      name: 'verify_success', url: 'success/'
      controller: require("./../verifications/success/success.coffee")
      template: require("./../verifications/success/success.jade")
    ,
      name: 'verify_fail', url: 'fail/'
      controller: require("./../verifications/fail/fail.coffee")
      template: require("./../verifications/fail/fail.jade")
    ]
  ,
    name: 'income', url: 'income/'
    controller: require('./../applications/income/income.coffee')
    template: require('./../applications/income/income.jade')
  ,
    name: 'pay', url: 'pay/'
    controller: require('./pay/pay.coffee')
    template: require('./pay/pay.jade')
  ,
    name: 'complete', url: 'complete/'
    template: require('./complete/complete.jade')
    controller: require('./complete/complete.coffee')
  ]



// WEBPACK FOOTER //
// ./components/payment/routes.coffee